import { render, staticRenderFns } from "./subject-builder.view.vue?vue&type=template&id=af476474&scoped=true&"
import script from "./subject-builder.view.ts?vue&type=script&lang=ts&"
export * from "./subject-builder.view.ts?vue&type=script&lang=ts&"
import style0 from "./subject-builder.view.scss?vue&type=style&index=0&id=af476474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af476474",
  null
  
)

export default component.exports